import {
  Item,
  ItemFacetsFilters,
  ItemFacetsResponse,
  ItemWithAllPrices,
  ManufacturerCandidate,
} from '@/api/items/items.types.ts';
import { AxiosInstance } from 'axios';

function buildFacetParams(filters?: ItemFacetsFilters): Record<string, string | number> {
  if (!filters) return {};
  const params: Record<string, string | number> = {};
  if (filters.priceListId) params.priceListId = filters.priceListId;
  if (filters.manufacturerId) params.manufacturerId = filters.manufacturerId;
  if (filters.itemGroupId) params.itemGroupId = filters.itemGroupId;
  return params;
}

export const createItemsApi = (api: AxiosInstance) => ({
  getAllItems: (priceListId?: number) =>
    api.get<Item[]>('/v1/items', { params: { priceListId } }),

  getAllItemsWithAllPrices: () =>
    api.get<ItemWithAllPrices[]>('/v1/items/all-prices'),

  getItemById: (itemId: string, priceListId?: number) =>
    api.get<Item>(`/v1/items/${itemId}`, { params: { priceListId } }),

  syncItems: () => api.post('/v1/items/sync'),

  getManufacturers: () =>
    api.get<ManufacturerCandidate[]>('/v1/items/manufacturers'),

  getItemFacets: (filters?: ItemFacetsFilters) =>
    api.get<ItemFacetsResponse>('/v1/items/facets', { params: buildFacetParams(filters) }),

  /**
   * Internal article export (MEK + all price lists + stock) as a blob.
   * `itemIds` narrows the export to the selected rows.
   */
  exportItemsWithAllPrices: (itemIds: string[], format: 'xlsx' | 'csv') =>
    api.post<Blob>(
      '/v1/items/export',
      { itemIds, format },
      { responseType: 'blob' },
    ),
});
